<template>
    <div class="product-card"
         :key="item.objectID"
         :class="{
        'product-card--thumbnail': (showAs == 'grid-view'),
        'product-card--list': (showAs == 'list-view'),
        'in-backorder': backorderProductIds.includes(item.sku) && !isProductSavedOrInCart(parseInt(item.objectID)),
        'in-cart': isProductSavedOrInCart(parseInt(item.objectID)),
        'has-bestb': hasBestB(item),
        'is-bestb': isBestB
    }">
        <div class="product-card__image">
            <a :href="`${item.url}?queryID=${item.__queryID}`" @click="sendEvent('click', item, 'Go to product detail page')">
                <template v-if="item.thumbnailPresent">
                    <img :src="`https://ranson.be/${item.thumbnail}`" :alt="item.title" class="product-card__image-asset">
                </template>
                <div v-else class="product-card__image-placeholder">
                    <svg xmlns="http://www.w3.org/2000/svg" width="426.41" height="325.68" viewBox="0 0 426.41 325.68">
                        <path d="M341.04.33C212.99,5.87,94.97,72.46,94.97,72.46c-192.94,115.24-32.17,188.43-32.17,188.43,80.84,40.08,186.36,59.93,186.36,59.93,2.69.61,5.3,1.14,7.87,1.6l-.03.02c3.24.61,23.84,4.7,44.76,2.69.67-.06,1.33-.13,1.98-.21.7-.08,1.4-.16,2.1-.25,1.41-.19,2.77-.41,4.1-.65.36-.07.72-.14,1.08-.21,1.36-.26,2.68-.55,3.96-.87.15-.04.3-.07.45-.11,21.73-5.46,31.25-17.6,36.64-24.17,49.4-63.6,70.7-185.14,70.7-185.14,12.21-62.71-8.24-90.84-31.62-103.32C367.78-2.79,341.04.33,341.04.33Z" fill="#e6e6e6"/>
                        <g fill="#fff">
                            <path d="M68.67,160.57h7.2c6.1,0,9.02-1.75,9.02-6.62s-2.92-6.49-9.02-6.49h-7.2v13.11ZM58.29,186.86v-48.02h18.04c11.81,0,18.88,4.22,18.88,14.86,0,7.59-3.57,11.75-9.99,13.69l10.71,19.47h-11.16l-9.99-18.11h-6.1v18.11h-10.39Z"/>
                            <path d="M120.78,168.49h11.29l-5.52-16.36h-.13l-5.65,16.36h.01ZM104.75,186.86l17-48.22h10.06l17,48.22h-10.71l-3.57-10.71h-16.35l-3.7,10.71h-9.73Z" />
                            <polygon points="159.71 186.86 159.71 138.84 170.29 138.84 190.41 169.47 190.54 169.47 190.54 138.84 200.27 138.84 200.27 186.86 190.54 186.86 169.58 155.97 169.45 155.97 169.45 186.86 159.72 186.86 159.71 186.86"/>
                            <path d="M213.07,175.95l7.98-4.74c2.66,5.26,7.46,8.18,12.98,8.18,4.87,0,8.37-1.82,8.37-5.52s-3.44-5.19-9.73-6.94c-8.57-2.4-17.52-4.61-17.52-14.67,0-8.96,7.01-14.34,17.33-14.34s15.7,4.74,19.08,9.86l-7.33,5.58c-2.53-4.09-7.14-6.81-11.81-6.81s-6.94,1.95-6.94,4.8c0,3.83,3.57,5.19,9.86,6.94,8.44,2.27,17.39,4.93,17.39,14.86,0,7.72-5.84,14.6-19.21,14.6-10.38,0-16.87-4.93-20.44-11.81h0Z" />
                            <path d="M297.55,162.84c0-10.06-4.67-16.16-12.07-16.16s-12.07,6.1-12.07,16.16,4.61,16.42,12.07,16.42,12.07-6.36,12.07-16.42ZM262.84,162.84c0-16.87,11.03-24.92,22.65-24.92s22.58,8.05,22.58,24.92-11.03,24.92-22.58,24.92-22.65-8.05-22.65-24.92Z"/>
                            <polygon points="320.27 186.86 320.27 138.84 330.85 138.84 350.97 169.47 351.1 169.47 351.1 138.84 360.83 138.84 360.83 186.86 351.1 186.86 330.14 155.97 330.01 155.97 330.01 186.86 320.28 186.86 320.27 186.86"/>
                        </g>
                    </svg>
                </div>
            </a>
            <a v-if="item.brand && item.brand.logo && item.brand.category" @click.prevent="brandClick(item.brand)" class="product-card__image-brand">
                <img :src="`https://ranson.be/${item.brand.logo}`" :alt="item.brand.title">
            </a>
            <div v-if="loggedIn && item.promo" class="product-card__promo-stone">
                <span>{{ $t("promo") }}</span>
                <svg width="88" height="68" viewBox="0 0 88 68" fill="#001FA0" xmlns="http://www.w3.org/2000/svg">
                    <path d="M69.6981 0.448091C43.5817 2.02244 19.724 16.0226 19.724 16.0226C-19.2567 40.212 13.8108 54.5935 13.8108 54.5935C30.4494 62.4939 52.0553 66.1798 52.0553 66.1798C52.6064 66.295 53.141 66.3942 53.6671 66.4791L53.6611 66.4833C54.3245 66.5966 58.5432 67.36 62.8061 66.8773C62.9427 66.8627 63.0771 66.8462 63.2095 66.8276C63.3521 66.8088 63.4947 66.7901 63.6373 66.7693C63.9244 66.7256 64.2012 66.676 64.4719 66.6224C64.5451 66.6069 64.6183 66.5913 64.6916 66.5758C64.9682 66.518 65.2367 66.4543 65.4968 66.3845C65.5273 66.3758 65.5578 66.3692 65.5883 66.3605C70.0045 65.1708 71.9056 62.66 72.9829 61.3004C82.8453 48.1482 86.7717 23.2675 86.7717 23.2675C89.0466 10.4258 84.7752 4.75523 79.96 2.28901C75.1451 -0.281351 69.6981 0.448091 69.6981 0.448091Z" />
                </svg>
            </div>
        </div>
        <div class="product-card__body">
            <div class="product-card__body-top">
                <div class="product-card__info-wrapper">
                    <div class="product-card__header">
                        <h4 class="product-card__sku">
                            <a :href="`${item.url}?queryID=${item.__queryID}`"
                               @click="sendEvent('click', item, 'Go to product detail page')">
                                {{ item.sku.replace("RANU-", "") }}
                            </a>
                        </h4>
                        <div v-if="item.icon && showWarehouseIcon" class="tag tag--warehouse-icon tag--desktop"
                             v-html="item.icon"></div>
                        <div v-if="loggedIn && item.focusAssortment.length"
                             class="tag tag--premium-selection tag--desktop" v-html="psLogo"></div>
                        <div v-if="loggedIn && item.ob" class="tag tag--brown tag--desktop"
                             :class="(item.bargainSale) ? 'tag--red' : 'tag--brown'">
                            {{ (item.bargainSale) ? $t("bargainSale") : $t("ob") }}
                        </div>
                        <div v-else-if="loggedIn && item.bargainSale" class="tag tag--red tag--desktop">
                            <span>{{ $t("bargainSale") }}</span></div>
                        <div v-if="itemIsNew(item)" class="tag tag--desktop">{{ $t("new") }}</div>
                        <div v-if="loggedIn && item.promo" class="tag tag--green tag--desktop">
                            {{ item.promoTeaser || $t("promo") }}
                        </div>
                        <stock-modal v-if="loggedIn && directOrder"
                                     :in-sales-app="inSalesApp"
                                     :sync-time="syncTime"
                                     :stock-lines-array="item.stockLines"/>
                        <div class="mobile-tags">
                            <div v-if="item.icon && showWarehouseIcon" class="tag tag--warehouse-icon"
                                 v-html="item.icon"></div>
                            <div v-if="loggedIn && item.focusAssortment.length" class="tag tag--premium-selection"
                                 v-html="psLogo"></div>
                            <div v-if="loggedIn && item.ob" class="tag tag--brown"
                                 :class="(item.bargainSale) ? 'tag--red' : 'tag--brown'">
                                {{ (item.bargainSale) ? $t("bargainSale") : $t("ob") }}
                            </div>
                            <div v-else-if="loggedIn && item.bargainSale" class="tag tag--red">
                                <span>{{ $t("bargainSale") }}</span></div>
                            <div v-if="itemIsNew(item)" class="tag">{{ $t("new") }}</div>
                            <div v-if="loggedIn && item.promo" class="tag tag--green">{{
                                    item.promoTeaser || $t("promo")
                                }}
                            </div>
                        </div>
                    </div>
                    <div class="product-card__info">
                        <div class="product-card__description">
                            <span class="product-card__description-icon" v-if="item.filters['Baktype'] && item.filters['Baktype'] !== 'None'">
                                <img :src="`/assets/img/baking-type/${$t(item.filters['Baktype'].toLowerCase())}.svg`"
                                     :title="$t(item.filters['Baktype']).replace('–','-').split('-')[1]"
                                     :alt="$t(item.filters['Baktype']).replace('–','-').split('-')[1]"/>
                            </span>
                            <div class="product-card__description-body">
                                <span class="product-card__title">{{ item.commercialName || item.title }}</span>

                                <p class="product-card__options" v-if="item.filters['Aantal in doos'] || item.weight || item.brand.title || item.volume">
                                    <template v-if="item.filters['Aantal in doos'] > 1">
                                        {{ item.filters["Aantal in doos"] }} {{ $t("stuks") }}
                                        <template v-if="item.weight || item.volume">
                                            x
                                        </template>
                                    </template>
                                    <template v-if="item.volume">
                                        {{ item.volume >= 1000 ? `${item.volume / 1000} L` : `${item.volume} ml` }}
                                    </template>
                                    <template v-else-if="item.weight">
                                        {{ item.weight >= 1000 ? `${item.weight / 1000} kg` : `${item.weight} g` }}
                                    </template>
                                    <span v-if="item.brand.title" class="relative z-50" @click="brandClick(item.brand)">
                                        <template v-if="item.filters['Aantal in doos'] > 1 || item.weight  || item.volume"> | </template>
                                        {{ item.brand.title }}
                                    </span>
                                </p>
                            </div>
                        </div>

                        <button class="product-card__link product-card__link--download" v-if="item.technicalSheet"
                                @click.prevent="technicalSheetUrl(loggedIn, item.objectID, item.technicalSheet, item.sku, item.commercialName || item.title)">
                            {{ $t("Download technical sheet") }}
                        </button>
                    </div>
                </div>
                <div class="product-card__price-wrapper" v-if="loggedIn || inKioskApp">
                    <product-price :price="defaultPrice"
                                   :price-fetched="priceFetched"
                                   :has-promo="item.promo"
                                   :discontinued="item.discontinued"
                                   :translations="{
                                'price': $t('price'),
                                'promotionPrice': $t('Promo tem') + ' ' + formatDate(item.promoEnd),
                                'yourPrice': $t('yourPrice'),
                                'discontinuedInfoMsg': $t('discontinuedInfoMsg'),
                                'discontinued': $t('discontinued')
                            }"
                    ></product-price>
                    <span v-if="volumeDiscounts.length > 1" class="product-card__volume-discount"
                          v-html="currentVolumeDiscount(volumeDiscounts, qty)"></span>
                    <best-b-info v-if="loggedIn && isBestB && showAs == 'list-view'" :item="item"
                                 :show-as="showAs"></best-b-info>
                </div>
            </div>
            <div class="product-card__body-bottom">
                <div class="info-actions">
                    <template v-if="loggedIn">
                        <form class="form-add-to-cart" action="">
                            <div class="form-add-to-cart__input-wrapper">
                                <label :for="`qty-${item.objectID}`" class="sr-only">{{ $t("Aantal") }}</label>

                                <input type="number" name="qty" class="form-add-to-cart__input qty"
                                       :id="`qty-${item.objectID}`"
                                       :min="getMinQty(item.multiples)"
                                       :step="getStepQty(item.multiples)"
                                       v-model="qty"
                                       @blur="toggleQtyFocus(null)"
                                       @change="updateQty($event, item)"
                                       @focus="toggleQtyFocus(`qty-${item.objectID}`)"
                                       @input="updateQty($event, item)">

                                <template v-if="directOrder">
                                    <button v-if="isSales && inSalesApp && user.id !== null" class="form-add-to-cart__button btn-cart" :disabled="!user" @click.prevent="addProductToCartModal(item)">
                                        <span v-if="addingToCartModal !== item.objectID" aria-hidden="true" class="fas fa-pen"></span>
                                        <span v-else aria-hidden="true" class="fas fa-circle-notch fa-spin"></span>
                                    </button>

                                    <button class="form-add-to-cart__button form-add-to-cart__button--filled btn-cart" :disabled="!user" @click.prevent="addProductToCart($event, item)">
                                        <span v-if="addingToCart !== item.objectID" aria-hidden="true" class="fas fa-shopping-basket"></span>
                                        <span v-else aria-hidden="true" class="fas fa-circle-notch fa-spin" style="padding: 0 1px;"></span>
                                    </button>
                                </template>

                                <template v-else>
                                    <button class="form-add-to-cart__button form-add-to-cart__button--filled" :disabled="!user"
                                            @click.prevent="addProductToOrder(item)">
                                        <span v-if="addingToCart !== item.objectID" :title="$t('Toevoegen')"
                                              aria-hidden="true" class="fas fa-plus"></span>
                                        <span v-else aria-hidden="true" class="fas fa-circle-notch fa-spin"
                                              style="padding: 0 1px;"></span>
                                    </button>
                                    <button class="form-add-to-cart__button form-add-to-cart__button--filled form-add-to-cart__button--delete"
                                            :disabled="!isProductSavedOrInCart(item.objectID)"
                                            @click.prevent="removeProductFromOrder(item.objectID)">
                                        <span :title="$t('Verwijderen')" aria-hidden="true" class="fas fa-times"></span>
                                    </button>
                                </template>
                            </div>
                            <button v-if="directOrder && loggedIn" class="form-add-to-cart__button form-add-to-cart__button--favorite" :class="{ 'form-add-to-cart__button--filled': userFavorites.includes(parseInt(item.objectID)) }" @click.prevent="toggleFavorite(item.objectID)">
                                <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512">
                                    <path d="M244 130.6l-12-13.5-4.2-4.7c-26-29.2-65.3-42.8-103.8-35.8c-53.3 9.7-92 56.1-92 110.3v3.5c0 32.3 13.4 63.1 37.1 85.1L253 446.8c.8 .7 1.9 1.2 3 1.2s2.2-.4 3-1.2L443 275.5c23.6-22 37-52.8 37-85.1v-3.5c0-54.2-38.7-100.6-92-110.3c-38.5-7-77.8 6.6-103.8 35.8l-4.2 4.7-12 13.5c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4zm34.9-57.1C311 48.4 352.7 37.7 393.7 45.1C462.2 57.6 512 117.3 512 186.9v3.5c0 36-13.1 70.6-36.6 97.5c-3.4 3.8-6.9 7.5-10.7 11l-184 171.3c-.8 .8-1.7 1.5-2.6 2.2c-6.3 4.9-14.1 7.5-22.1 7.5c-9.2 0-18-3.5-24.8-9.7L47.2 299c-3.8-3.5-7.3-7.2-10.7-11C13.1 261 0 226.4 0 190.4v-3.5C0 117.3 49.8 57.6 118.3 45.1c40.9-7.4 82.6 3.2 114.7 28.4c6.7 5.3 13 11.1 18.7 17.6l4.2 4.7 4.2-4.7c4.2-4.7 8.6-9.1 13.3-13.1c1.8-1.5 3.6-3 5.4-4.5z"/>
                                </svg>
                            </button>
                        </form>

                        <best-b-info v-if="loggedIn && isBestB && showAs == 'grid-view'" :item="item" :show-as="showAs"></best-b-info>

                        <div v-if="isSales" class="sales-only-actions">
                            <a v-if="inSalesApp && isBestB && user.id !== null" href=""
                               class="product-card__link product-card__link--best-b"
                               @click.prevent="removeFromBestB(item)">
                                {{ $t("BestB") }}
                            </a>
                            <a :href="`${item.url}?queryID=${item.__queryID}`" class="product-card__link product-card__link--details">{{ $t("Details bekijken") }}</a>
                        </div>
                    </template>
                    <template v-else>
                        <a :href="loginUrl" class="btn">
                            {{ $t("Log in to order") }}
                        </a>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {helpers} from "@/js/mixins/helpers.js";
import StockModal from "@/vue/StockModal.vue";
import BestBInfo from "@/vue/components/BestBInfo.vue";
import ProductPrice from "@/vue/ProductPrice.vue";
import debounce from "debounce";
import {nextTick} from "vue-instantsearch/src/util/vue-compat";

export default {
    name: "ProductThumbCard",
    mixins: [helpers],

    components: {
        ProductPrice,
        BestBInfo,
        StockModal
    },

    data() {
        return {
            showWarehouseIcon: this.isSales,
            psLogo: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 159.11 174.68" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><defs><linearGradient id="a" x1="0" y1="88.66" x2="159.11" y2="88.66" gradientTransform="matrix(1 0 0 -1 0 176)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#efbe48"/><stop offset=".12" stop-color="#f8db77"/><stop offset=".21" stop-color="#ffee97"/><stop offset=".67" stop-color="#efa64c"/><stop offset="1" stop-color="#efbe48"/></linearGradient></defs><path d="M55.15 174.68c-5.37 0-10.35-2.79-13.17-7.35L2.3 102.87C-2.18 95.59.09 86.07 7.36 81.6c7.27-4.48 16.8-2.2 21.27 5.06l26.52 43.08L130.49 7.36c4.47-7.27 13.98-9.55 21.27-5.06 7.27 4.48 9.53 14 5.06 21.27L68.31 167.33a15.47 15.47 0 01-13.17 7.35h.01z" fill="url(#a)"/></svg>`,
            qty: this.propQty
        };
    },

    props: {
        item: {
            type: Object,
            default: () => {
                return {
                    __queryID: 0,
                    objectID: 5222500,
                    sku: "00019276",
                    icon: "☖",
                    ob: false,
                    bargainSale: false,
                    promo: true,
                    promoTeaser: "5+1",
                    promoEnd: 1703977200,
                    brand: {
                        category: {
                            lvl0: "M",
                            lvl1: "M > Materne"
                        },
                        title: "Materne",
                        uri: "webshop/merk/materne",
                        brandPage: false,
                        logo: "/assets/uploads/brands/_logoThumbnail/Materne.png?v=1655441007"
                    },
                    focusAssortment: [],
                    url: "/webshop/product/x11-8kg-pruimenspijs-materne",
                    images: [
                        "https://www.ranson.be/assets/uploads/products/00001945.jpg"
                    ],
                    thumbnail: "/assets/uploads/products/_productThumbnail/00001945.jpg?v=1675147340",
                    thumbnailPresent: true,
                    title: "X11.8KG PRUIMENSPIJS MATERNE",
                    commercialName: "Pruimenmoes",
                    qtyPreceding: 5,
                    qtyLast: 15,
                    lastSellingPrice: 20.25,
                    lastOrderDate: new Date(),
                    dateCreated: 1621340447,
                    filters: {
                        "Aantal in doos": 1,
                        "Baktype": "None",
                        "Oven temperatuur": 0,
                        "Baktijd": 0,
                        "Ontdooitijd": 0,
                        "Rijstijd": 0,
                        "Materiaal": ""
                    },
                    weight: 11800,
                    volume: 0,
                    technicalSheet: "https://www.ranson.be/product/technical-sheet/MDAwMDE5NDU",
                    stockLines: [{
                        "inventSiteId": "01",
                        "inventSiteName": "Harelbeke",
                        "minInventOnHand": 0,
                        "availPhysical": 0,
                        "ranDeliveryFrequency": 10,
                        "status": "light-blue"
                    }, {
                        "inventSiteId": "04",
                        "inventSiteName": "Ranshop Harelbeke",
                        "minInventOnHand": 0,
                        "availPhysical": 0,
                        "ranDeliveryFrequency": 10,
                        "status": "light-blue"
                    }, {
                        "inventSiteId": "05",
                        "inventSiteName": "Ranshop Hoeselt",
                        "minInventOnHand": 0,
                        "availPhysical": 0,
                        "ranDeliveryFrequency": 10,
                        "status": "light-blue"
                    }, {
                        "inventSiteId": "06",
                        "inventSiteName": "Antwerpen",
                        "minInventOnHand": 0,
                        "availPhysical": 19,
                        "ranDeliveryFrequency": 10,
                        "status": "green"
                    }, {
                        "inventSiteId": "11",
                        "inventSiteName": "Brussel",
                        "minInventOnHand": 0,
                        "availPhysical": 0,
                        "ranDeliveryFrequency": 10,
                        "status": "light-blue"
                    }, {
                        "inventSiteId": "12",
                        "inventSiteName": "Hoeselt",
                        "minInventOnHand": 0,
                        "availPhysical": 0,
                        "ranDeliveryFrequency": 10,
                        "status": "light-blue"
                    }]
                };
            }
        },
        showAs: {
            type: String,
            default: "list-view" // grid-view, list-view
        },
        loggedIn: {
            type: Boolean,
            default: true
        },
        isSales: {
            type: Boolean,
            default: false
        },
        inSalesApp: {
            type: Boolean,
            default: false
        },
        inKioskApp: {
            type: Boolean,
            default: false
        },
        isBestB: {
            type: Boolean,
            default: true
        },
        user: {
            type: [Array, Object, Boolean],
            default: false
        },
        syncTime: {
            type: String,
            default: ""
        },
        loginUrl: {
            type: String,
            default: "/login"
        },
        productsInOrder: {
            type: Array,
            default: () => []
        },
        defaultPrice: {
            type: String,
            default: ""
        },
        priceFetched: {
            type: Boolean,
            default: false
        },
        volumeDiscounts: {
            type: [Array, Object],
            default: () => []
        },
        directOrder: {
            type: Boolean,
            default: true
        },
        addingToCartModal: {
            type: Boolean,
            default: false
        },
        addingToCart: {
            type: Boolean,
            default: false
        },
        propQty: {
            type: String,
            default: "1"
        }
    },

    mounted() {
        const productInOrder = this.productsInOrder.find(product => parseInt(product.id) === parseInt(this.item.objectID));
        if (productInOrder && productInOrder.qty) {
            this.qty = productInOrder.qty;
        } else if (this.item.multiples.length) {
            this.qty = this.getMinQty(this.item.multiples);
        } else {
            this.qty = this.propQty;
        }
    },

    methods: {
        debounceInput: debounce(function ($event, item) {
            this.updateQty($event, item);
        }, 100),

        brandClick(brand) {
            if (brand.brandPage) {
                window.location = brand.brandPage;
            } else {
                this.$parent.brandFilter = brand.category;
            }
        },

        sendEvent(eventType, eventItem, eventParams) {
            this.$emit("send-event", eventType, eventItem, eventParams);
        },

        toggleQtyFocus(elementId) {
            this.$emit("toggle-qty-focus", elementId);
        },

        updateQty($event, item) {
            this.$emit("update-qty", $event, item);
        },

        addProductToCartModal(item) {
            this.$emit("add-product-to-cart-modal", item);
            this.qty = this.propQty;
        },

        addProductToCart($event, item) {
            this.$emit("add-product-to-cart", $event, item, (qty) => this.updateQtyInternal(qty));
        },

        updateQtyInternal(qty) {
            this.qty = qty;
        },

        addProductToOrder(item) {
            this.$emit("add-product-to-order", item);
        },

        removeProductFromOrder(item) {
            this.$emit("remove-product-from-order", item);
        },

        removeFromBestB(item) {
            this.$emit("remove-from-best-b", item);
        },

        itemIsNew(item) {
            if (item.dateCreated) return new Date(item.dateCreated * 1000) > (new Date().setDate(new Date().getDate() - 30)); // 30 days ago from today
            return false;
        },

        toggleFavorite(objectId) {
            fetch(`${window.rootUrl}actions/ranson-module/customer/toggle-favorite`, {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    "X-CSRF-TOKEN": window.csrfToken
                },
                body: JSON.stringify({
                    productId: objectId
                })
            })
                .then(res => res.json())
                .then(data => {
                    if (data.success) {
                        if (this.userFavorites.includes(parseInt(objectId))) {
                            this.userFavorites = this.userFavorites.filter(id => parseInt(id) !== parseInt(objectId));
                        } else {
                            this.userFavorites.push(parseInt(objectId));
                        }

                        this.$notify({
                            text: data.message,
                            type: "success"
                        });

                    }
                })
                .catch((error) => {
                    console.error("Error:", error);
                    this.$notify({
                        text: "Could not add favorite. Please try again later.",
                        type: "success"
                    });

                });
        },

        getProductQty(objectID, multiples) {

            const productInOrder = this.isProductSavedOrInCart(objectID);
            if (productInOrder) return productInOrder.qty;

            if (multiples) {
                // Check if customer is linked to one of the inventSiteId's
                // in the object
                const inventSiteId = this.user?.inventSiteId ?? "";

                const specificMultiple = multiples.filter(el => el.inventSiteId == inventSiteId);
                const globalMultiple = multiples.filter(el => el.inventSiteId == "");

                if (specificMultiple.length) {
                    return (specificMultiple[0].lowestQty > 0) ? specificMultiple[0].lowestQty : 1;
                }

                if (globalMultiple.length) {
                    return (globalMultiple[0].lowestQty > 0) ? globalMultiple[0].lowestQty : 1;
                }
            }

            return 1;
        },

        isProductSavedOrInCart(id) {
            const product = this.productsInOrder.find(product => parseInt(product.id) === parseInt(id));
            if (product) {
                if (this.directOrder) return true;
                if (!this.directOrder && product.type === "saved") return true;
            }

            return false;
        },


        currentVolumeDiscount(volumeDiscounts, qty) {
            if (volumeDiscounts.length > 1) {

                // First we get the current applied staffel,
                // we dot this by getting the index of the relevant staffel in the array
                let currentIndex = volumeDiscounts.findIndex((volumeDiscount) => {
                    return volumeDiscount.quantityAmountFrom <= qty && volumeDiscount.quantityAmountTo > qty;
                });

                // If we find one we'll add 1 to get the next staffel
                let nextIndex = currentIndex + 1;

                // Now we check if the index is available in the array
                if (nextIndex > (volumeDiscounts.length - 1)) {
                    return "";
                }

                let volumeDiscount = volumeDiscounts[nextIndex];
                return window.i18n.t("volumeDiscountText", {
                    qty: volumeDiscount.quantityAmountFrom,
                    price: this.formatCurrency(volumeDiscount.amount)
                });
            }
        },
        hasBestB(item) {
            return item.qtyPreceding !== null || item.qtyLast !== null || parseInt(item.qtyPreceding) > 0 || parseInt(item.qtyLast) > 0;
        }
    },

    computed: {

        backorderProductIds() {
            if (this.$parent && this.$parent.$parent && this.$parent.$parent.$parent && this.$parent.$parent.$parent.backorderProductIds !== undefined) {
                return this.$parent.$parent.$parent.backorderProductIds;
            } else {
                return [];
            }
        },

        userFavorites: {
            get() {
                if (this.$parent && this.$parent.userFavorites !== undefined) {
                    return this.$parent.userFavorites;
                } else if (this.$parent && this.$parent.$parent && this.$parent.$parent.$parent && this.$parent.$parent.$parent.userFavorites !== undefined) {
                    return this.$parent.$parent.$parent.userFavorites;
                } else {
                    return [];
                }
            },

            set(value) {
                if (this.$parent && this.$parent.userFavorites !== undefined) {
                    this.$parent.userFavorites = value;
                } else if (this.$parent && this.$parent.$parent && this.$parent.$parent.$parent && this.$parent.$parent.$parent.userFavorites !== undefined) {
                    this.$parent.$parent.$parent.userFavorites = value;
                }
            }
        }
    }
};
</script>